class ResetBundlePaddlePicker extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    const model = event.target.closest('.reset-bundle-picker__model');
    if (model && this.contains(model) && model.dataset.model) {
      this.selectModel(model);
      return;
    }

    const swatch = event.target.closest('.reset-bundle-picker__swatch');
    if (!swatch || !this.contains(swatch)) return;

    if (swatch.dataset.backpackColor) {
      this.selectBackpack(swatch);
      return;
    }

    if (!swatch.dataset.color || !swatch.dataset.slot) return;
    this.selectPaddle(swatch);
  }

  selectModel(card) {
    this.querySelectorAll('.reset-bundle-picker__model').forEach((btn) => {
      btn.classList.remove('is-selected');
      btn.setAttribute('aria-pressed', 'false');
    });
    card.classList.add('is-selected');
    card.setAttribute('aria-pressed', 'true');

    const input = this.querySelector('[data-model-input]');
    if (input) input.value = card.dataset.model;

    const label = this.querySelector('[data-selected-model]');
    if (label) label.textContent = card.dataset.model;

    if (card.dataset.paddleImage) {
      document.dispatchEvent(new CustomEvent('reset:bundle:paddle', {
        detail: { src: card.dataset.paddleImage, alt: card.dataset.model }
      }));
    }
  }

  selectPaddle(swatch) {
    const slot = swatch.dataset.slot;
    const color = swatch.dataset.color;
    const group = swatch.closest('.reset-bundle-picker__swatches');

    group.querySelectorAll('.reset-bundle-picker__swatch').forEach((btn) => {
      btn.classList.remove('is-selected');
      btn.setAttribute('aria-pressed', 'false');
    });

    swatch.classList.add('is-selected');
    swatch.setAttribute('aria-pressed', 'true');

    const input = this.querySelector(`input[name="properties[Paddle ${slot} Color]"]`);
    if (input) input.value = color;

    const label = this.querySelector(`[data-selected-label="${slot}"]`);
    if (label) label.textContent = color;
  }

  selectBackpack(swatch) {
    const group = swatch.closest('.reset-bundle-picker__swatches');
    const color = swatch.dataset.backpackColor;

    group.querySelectorAll('.reset-bundle-picker__swatch').forEach((btn) => {
      btn.classList.remove('is-selected');
      btn.setAttribute('aria-pressed', 'false');
    });

    swatch.classList.add('is-selected');
    swatch.setAttribute('aria-pressed', 'true');

    const input = this.querySelector('input[name="properties[Backpack Color]"]');
    if (input) input.value = color;
  }
}

if (!customElements.get('reset-bundle-paddle-picker')) {
  customElements.define('reset-bundle-paddle-picker', ResetBundlePaddlePicker);
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.reset-kit-gallery').forEach((gallery) => {
    const sectionId = gallery.id.replace('reset-kit-gallery-', '');
    const sourceTpl = document.getElementById(`reset-kit-sources-${sectionId}`);
    if (!sourceTpl) return;

    const sources = {};
    sourceTpl.content.querySelectorAll('[data-kit-id]').forEach((node) => {
      sources[node.dataset.kitId] = {
        src: node.dataset.src,
        caption: node.dataset.caption || ''
      };
    });

    const heroBtn = gallery.querySelector('.reset-kit-gallery__hero-btn');
    const heroImg = heroBtn?.querySelector('img');
    const panel = gallery.querySelector('[data-kit-panel]');
    const panelImg = panel?.querySelector('.reset-kit-gallery__detail-image');
    const panelCaption = panel?.querySelector('.reset-kit-gallery__detail-caption');

    const setActive = (target, card) => {
      gallery.querySelectorAll('.reset-kit-gallery__card, .reset-kit-gallery__hero-btn').forEach((el) => {
        el.classList.remove('is-active');
        el.setAttribute('aria-pressed', 'false');
      });

      if (card) {
        card.classList.add('is-active');
        card.setAttribute('aria-pressed', 'true');
      }

      const data = sources[target];
      if (!data || !heroImg) return;

      heroImg.src = data.src;
      heroImg.alt = data.caption;

      if (panel && panelImg && panelCaption) {
        panel.hidden = false;
        panelImg.src = data.src;
        panelImg.alt = data.caption;
        panelCaption.textContent = data.caption;
      }
    };

    gallery.querySelectorAll('[data-kit-target]').forEach((card) => {
      card.addEventListener('click', () => setActive(card.dataset.kitTarget, card));
    });
  });
});

document.addEventListener('click', (event) => {
  const btn = event.target.closest('.reset-bundle-includes__item-btn');
  if (!btn || !btn.dataset.includeSrc) return;
  document.querySelectorAll('.reset-bundle-includes__item-btn').forEach((b) => b.classList.remove('is-active'));
  btn.classList.add('is-active');
  document.dispatchEvent(new CustomEvent('reset:bundle:paddle', {
    detail: { src: btn.dataset.includeSrc, alt: btn.dataset.includeAlt || '' }
  }));
});
